import React, { useState } from "react";
import style from "./style.module.sass";
import { useTheme } from "@material-ui/core/styles";
import { NavLink } from "react-router-dom";
import { Button } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import config from "../../../../config";
import { checkUserRight } from "../../../../utils";
import { useSelector } from "react-redux";
import ErrorPopup from "../../../Analysis/ModalWindows/ErrorModal";
import { ArrowBackIos } from "@material-ui/icons"

function Dashboard() {
  const { t } = useTranslation();
  const user = useSelector(state => state.userData.user);
  const groups = useSelector(state => state.adminData.groups)
  const [error, setError] = useState(null);
  const { theme: { bgColors, borderColors, colors } } = useTheme()
  const themeState = useSelector(state => state.userData.theme || localStorage.getItem('theme') || config.THEMES_MODES.LIGHT)

  const isContrast = themeState !== config.THEMES_MODES.LIGHT


  const isSingleGroupUser = Object.keys(groups).length === 1 
  const linkToGroup = isSingleGroupUser ? `/administration/group/update/${Object.keys(groups)[0]}` : "/administration/groups"

  return (
    <div className={style.mainCont}>
      <NavLink to="/administration" exact={true} style={{ textDecoration: "none" }}>
        <ErrorPopup error={error} setError={setError} />
        <Button style={{backgroundColor: bgColors.bgBlue1000, color: colors.colorContrast}} variant="contained" title={t('accessibility_admin_to-administration')}
          className={`d-flex align-items-center ${style.breadcrumb}`}>
          <ArrowBackIos className='mr-1' />
          {t("Administration")}
        </Button>
      </NavLink>
      <ul style={{ borderColor: borderColors.borderPrimary400 }}>
        {
          config.administration.map(l => {
            if (l?.rights?.length && !checkUserRight(user, l.rights))
              return null
            return (
              <li key={l.id} className={``} style={{ borderColor: borderColors.borderPrimary400 }}>
                <div title={t(`accessibility_admin_card-${l.title}`)}>
                  <NavLink
                    className={style.link}
                    style={{ color: isContrast ? colors.colorText : colors.colorMutedText }}
                    to={l.id === 1 ? linkToGroup : l.link}>
                    <p className={`m-0`}>
                      {t(l.id) === "2" ? t("Word lists") : t(l.title)}
                    </p>
                  </NavLink>
                </div>
              </li>
            )
          })
        }
      </ul>
    </div>
  )
}

export default Dashboard;
